<template>
  <div class="address">
    <div class="title">
      <div>收货地址</div>
      <div>
        <el-button @click="() => {add = true}" size="small" type="primary">新增</el-button>
      </div>
    </div>
    <template v-if="list.length">
      <div v-for="(item, index) in list" :key="index">
        <div v-if="!item.edit" class="address-row">
          <div class="info-group">
            <div class="item">
              <span class="label">收货人</span>
              <span>{{ item.name }}</span>
            </div>
            <div class="item">
              <span class="label">联系电话</span>
              <span>{{ item.phoneNumber }}</span>
            </div>
            <div class="item">
              <span class="label">所在地区</span>
              <span>{{ item.contactCityId ? item.contactProvinceName+item.contactCityName+item.contactAreaName : '' }}</span>
            </div>
            <div class="item">
              <span class="label">是否为默认</span>
              <span>{{ item.isDefault ? '是' : '否' }}</span>
            </div>
            <div class="item" style="width: 100%;">
              <span class="label">详细地址</span>
              <span>{{ item.contactAddrs }}</span>
            </div>
          </div>
          <div class="button-group">
            <el-button @click="edit(index)" icon="el-icon-edit" type="primary" plain>编辑</el-button>
            <el-button @click="disuse(item.id)" icon="el-icon-circle-close" type="info" plain>删除</el-button>
          </div>
        </div>
        <EditAddress v-if="item.edit" :formData="item" @refresh="refresh" />
      </div>
    </template>
    <Empty v-if="!add && !list.length" />
    <EditAddress v-if="add" @refresh="refresh" />
  </div>
</template>
<script>
import EditAddress from './editAddress.vue';
import UserDrawer from '@/api/userDrawer';
import Empty from '@/components/empty.vue';
export default {
  name: 'ADDRESS',
  components: {
    EditAddress,
    Empty,
  },
  data () {
    return {
      add: false,
      list: [],
      labelWidth: '120px',
    };
  },
  mounted () {
    this.queryList();
  },
  methods: {
    edit (index) {
      this.$set(this.list[index], 'edit', true);
    },
    refresh (id) {
      if (id) {
        this.list.map(item => {
          if (id === item.id) {
            item.edit = false;
          }
        });
      } else {
        this.add = false;
        this.queryList();
      }
    },
    disuse (id) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await UserDrawer.deleteAddress({ id });
        this.$message({
          type: 'success',
          message: '删除成功!',
        });
        this.queryList();
      }).catch(() => {});
    },
    async queryList () {
      let Api = '';
      const userInfo = this.$local.get('userInfo') ? JSON.parse(this.$local.get('userInfo')) : {};
      if (userInfo.isPersonal) {
        Api = UserDrawer.addressList;
      } else {
        Api = UserDrawer.addressOwn;
      }
      const { body } = await Api();
      this.list = body || [];
    },
  },
};
</script>
<style lang="scss" scoped>
.address {
  padding: 15px;
  border-radius: 6px;
  background-color: #FFFFFF;
  margin-bottom: 10px;
  .title {
    padding-bottom: 15px;
    margin-bottom: 15px;
    border-bottom: 1px solid #DFE2E8;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .address-row {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    border-radius: 4px;
    border: 1px solid #DFE2E8;
    margin-bottom: 20px;
    .info-group {
      display: inline-flex;
      flex-wrap: wrap;
      .item {
        display: inline-flex;
        padding: 6px 10px;
        width: 50%;
        .label {
          flex-shrink: 0;
          width: 100px;
          text-align: right;
          padding-right: 15px;
          color: #929AA6;
        }
      }
    }
    .button-group {
      padding-left: 50px;
      flex-shrink: 0;
    }
    &:hover {
      background-color: #f9fafb;
    }
  }
}
</style>
